module.exports = __webpack_public_path__ + "img/haida-giraff.7c8e5d49.jpg";